import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../features/auth/RequirePermission';
import { PeriodsPage } from '../../features/periods/PeriodsPage';

export const Route = createFileRoute('/_app/periods')({
  component: () => (
    <RequirePermission permission="period.manage">
      <PeriodsPage />
    </RequirePermission>
  ),
});
